import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "../../axios";
import classes from "./Layout.module.css";
import Login from "../../components/authentication/Login/Login";
import Account from "../../components/Account/Account";
import Organization from "../../components/Organization/Organization";
import * as actions from "../../store/actions/auth";
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

const Layout = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect");
  const [accountData, setAccountData] = useState(null);
  const [organizationData, setOrganizationData] = useState(null);

  useEffect(() => {
    // If user is already authenticated and there's a redirectUrl,
    // generate session code and redirect back
    if (props.isAuthenticated && redirectUrl && props.token) {
      dispatch(actions.generateSessionCode(redirectUrl));
      return;
    }

    if (props.isAuthenticated && !redirectUrl) {
      if (location.pathname === '/') {
        navigate('/account');
      }
      // Fetch account data once
      axios.get("/account")
        .then((response) => {
          setAccountData(response.data);
        })
        .catch(() => {
          // Silently fail
        });

      // Fetch organization data once
      axios.get("/organization")
        .then((response) => {
          setOrganizationData(response.data);
        })
        .catch(() => {
          // Silently fail
        });
    }
  }, [props.isAuthenticated, redirectUrl, props.token]);

  // If there's a redirect parameter and we're not yet authenticated, show login form.
  const showLogin = !props.isAuthenticated || (!!redirectUrl && !props.token);

  const handleLogoutClick = () => {
    props.logout();
  };

  if (showLogin) {
    return <Login {...props} />;
  }

  return (
    <div className={classes.layoutContainer}>
      <header className={classes.header}>
        <div className={classes.logo}>Allorado</div>
        <div className={classes.userInfo}>
          <span className={classes.userEmail}>{accountData?.email || props.username}</span>
          <button onClick={handleLogoutClick} className={classes.logoutButton}>
            Log out
          </button>
        </div>
      </header>
      
      <div className={classes.mainContainer}>
        <aside className={classes.sidebar}>
          <nav className={classes.nav}>
            <Link
              className={`${classes.navItem} ${location.pathname === '/account' ? classes.navItemActive : ''}`}
              to="/account"
            >
              Account
            </Link>
            <Link
              className={`${classes.navItem} ${location.pathname === '/organization' ? classes.navItemActive : ''}`}
              to="/organization"
            >
              Organization
            </Link>
          </nav>
        </aside>
        
        <main className={classes.content}>
          <Routes>
            <Route path="/account" element={<Account accountData={accountData} onAccountUpdate={setAccountData} />} />
            <Route path="/organization" element={<Organization organizationData={organizationData} onOrganizationUpdate={setOrganizationData} />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Layout;
